// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".lCNK6FEjx{position:relative}.IZFJJXYJx{padding-left:40px}.IZFJJXYJx::before{visibility:hidden;position:absolute;width:12px;height:12px;margin:4px;left:8px;top:50%;margin-top:-6px}.IZFJJXYJx._7ubjHtWjx{background-color:var(--ui-subtle-active)}.IZFJJXYJx._7ubjHtWjx::before{visibility:visible}._3Z4IR1v3x{margin-right:8px}._3Z4IR1v3x,._3Z4IR1v3x label{display:block}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"option": "lCNK6FEjx",
	"single": "IZFJJXYJx lCNK6FEjx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["icon-before-check"] + "",
	"selected": "_7ubjHtWjx",
	"checkbox": "_3Z4IR1v3x"
};
module.exports = exports;
